import { Pill } from "./Pill";
import { STATE_WORDS, displayState, type DisplayState } from "./state";

export { STATE_WORDS, displayState, type DisplayState };

interface StateBadgeProps {
  state: DisplayState;
  className?: string;
}

/** A pill that names a state in words, drawn dashed when it is a proposal. */
export function StateBadge({ state, className }: StateBadgeProps) {
  return (
    <Pill tone={state} className={className}>
      {STATE_WORDS[state]}
    </Pill>
  );
}
